import { Component, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../auth.service';
import { isCountryCodeBelgian } from '../../../shared/countries/country-service';

@Component({
  selector: 'app-first-login-popup',
  templateUrl: './first-login-popup.component.html',
  styleUrls: ['./first-login-popup.component.scss'],
})
export class FirstLoginPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<FirstLoginPopupComponent>,
    private readonly ngZone: NgZone,
    private readonly authService: AuthService,
  ) {}

  get welcomeTextKey(): string {
    return isCountryCodeBelgian(this.authService.getCountry())
      ? 'login.first_popup.welcome.text_be'
      : 'login.first_popup.welcome.text';
  }

  close(): void {
    this.ngZone.run(() => this.dialogRef.close());
  }
}
